import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { Ability } from '@casl/ability';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AbilityContext = createContext<Ability>(undefined!);

export default createContextualCan(AbilityContext.Consumer);
